// extracted by mini-css-extract-plugin
export default {"dialogMultiButton":"EditFavoriteDialog_dialogMultiButton__YBN-e"};